import { FC, useState } from 'react'

import { SequenceMenu } from '@sequencehq/core-components'

import { CreateCustomerForm } from 'Customers/components/drawers/CreateCustomer/CreateCustomerForm'

export const LinkToNewCustomerMenuItem: FC<{
  testIdPrefix: string
  eventId: string
  alias: string
  onClose: () => void
}> = ({ testIdPrefix, eventId, alias, onClose }) => {
  const [showForm, setShowForm] = useState(false)

  return (
    <>
      <SequenceMenu.Item
        key="link-to-new-customer"
        uuid="link-to-new-customer"
        label="Link to a new customer"
        data-testid={`${testIdPrefix}.${eventId}.menuItem.linkToNewCustomer`}
        onClick={e => {
          e.stopPropagation()
          setShowForm(true)
        }}
      />
      {showForm && (
        <CreateCustomerForm
          onClose={() => {
            setShowForm(false)
            onClose()
          }}
          prefill={{ customerAliases: [alias] }}
        />
      )}
    </>
  )
}
